// Preview Mode emulation of the two plan READ RPCs the recovery-plans page calls with `p_plan_id`
// (fn_recovery_plan_state, fn_recovery_plan_review_list) — enough for UI verification of the plan
// panel and its Word agreement (D-212). The plan row itself lives in data.ts `recovery_plans`.
// Read-only: no lifecycle RPC is emulated here.

type Row = Record<string, unknown>;
type Result<T> = { data: T; error: null | { message: string } };

const PLAN_ID = 'pl000000000001' + '0'.repeat(22);
const CUSTOMER_ID = 'cu000000000001' + '0'.repeat(22);

const INSTALLMENTS: readonly Row[] = [
  { seq: 1, amount: '1800.2500', paid_amount: '1800.2500', due: '2026-07-01', derived: 'paid', overdue: false },
  { seq: 2, amount: '1080.1500', paid_amount: '0.0000', due: '2026-08-03', derived: 'unpaid', overdue: true },
  { seq: 3, amount: '720.1000', paid_amount: '0.0000', due: '2026-10-01', derived: 'unpaid', overdue: false },
].map((i) => ({
  installment_id: `in${String(i.seq).padStart(12, '0')}`.padEnd(36, '0'),
  seq: i.seq,
  amount: i.amount,
  paid_amount: i.paid_amount,
  nominal_due_date: i.due,
  due_date: i.due,
  adjustment_reason: 'NONE',
  derived_status: i.derived,
  is_overdue: i.overdue,
}));

function planState(): Row {
  const next = INSTALLMENTS[1]!;
  return {
    plan_id: PLAN_ID,
    customer_id: CUSTOMER_ID,
    status: 'ACTIVE',
    currency: 'GEL',
    principal_amount: '3600.5000',
    template_id: 'tp000000000001' + '0'.repeat(22),
    superseded_by_plan_id: null,
    activated_at: '2026-07-01T09:05:00Z',
    is_breached: true,
    kpi: {
      paid_amount: '1800.2500',
      remaining_amount: '1800.2500',
      delay_days: 50,
      next_installment: {
        installment_id: next['installment_id'], seq: 2, due_date: '2026-08-03',
        amount: '1080.1500', paid_amount: '0.0000', remaining_amount: '1080.1500',
      },
    },
    installments: INSTALLMENTS,
  };
}

/** `undefined` = not a plan RPC (the caller falls through to its other handlers). */
export function previewRecoveryPlanRpc(fn: string, args: Row): Result<unknown> | undefined {
  if (fn !== 'fn_recovery_plan_state' && fn !== 'fn_recovery_plan_review_list') return undefined;
  if (args['p_plan_id'] !== PLAN_ID) return { data: null, error: { message: 'RECOVERY_PLAN_NOT_FOUND' } };
  if (fn === 'fn_recovery_plan_state') return { data: planState(), error: null };
  return { data: { plan_id: PLAN_ID, open_count: 0, flags: [] }, error: null };
}
